import React from 'react';
import { useTransition } from 'react-spring';

import { IToastMessage } from '~/hooks/toast';

import Toast from './Toast';

import { Container } from './styles';

interface IToastContainerProps {
  messages: IToastMessage[];
}

export default function ToastContainer({ messages }: IToastContainerProps) {
  const messagesWithTransitions = useTransition(
    messages,
    message => message.id,
    {
      from: { right: '-120%', opacity: 0.5 },
      enter: { right: '0%', opacity: 1 },
      leave: { right: '-120%', opacity: 0.5 },
    },
  );

  return (
    <Container>
      {messagesWithTransitions.map(({ item, key, props }) => (
        <Toast key={key} message={item} style={props} />
      ))}
    </Container>
  );
}
